import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  grid-area: content;
`;

/*
 * Component.
 */

export const ComposerSectionContent: FC<PropsWithChildren<unknown>> = (props) => (
  <StyledContentDiv>{props.children}</StyledContentDiv>
);
